import angular from 'angular';
import 'angular-ui-router';
import 'angular-ui-router-title';
import 'jquery-minicolors/jquery.minicolors.min'
import 'jquery-minicolors/jquery.minicolors.png'
import 'angular-minicolors/angular-minicolors';
import BudgetIndex from './budgetIndex';
import BudgetsTable from './budgetsTable.js';

export default angular.module('app.components.budget', [
    'ui.router',
    'minicolors',
    BudgetIndex.name,
    BudgetsTable.name,
])
    .config(function($stateProvider){
        $stateProvider
            .state('app.budget', {
                abstract: true,
                url: '/budgets/:gameId',
                template: '<ui-view/>',
                data: {
                    permissions: {
                        except: ['anonymous', 'SELLER_ONLY'],
                        redirectTo: 'login'
                    }
                },
                resolve: {
                    updateCurrentGame: function($stateParams,GamesResource,currentGame){
                        return GamesResource.one($stateParams.gameId).get().then(game => {
                            currentGame.onNext(game);
                        });
                    }
                }
            })
            .state('app.budget.index', {
                url: '',
                template: '<budget-index></budget-index>',
                resolve: {
                    $title: ($filter) => {
                        return $filter('translate')('$state.app.budget.index');
                    }
                }
            })
    })



/** WEBPACK FOOTER **
 ** ./src/components/budget/budget.js
 **/